"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _context = require("../../context");

var _utils = require("../../utils");

var _constants = require("../constants");

var _utils2 = require("../utils");

var _interfaces = require("./interfaces");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Ring = (0, _context.styledWithTheme)('div')(function (_ref) {
  var selectors = _ref.theme.selectors,
      colorScheme = _ref.colorScheme,
      disabled = _ref.disabled,
      error = _ref.error;
  var isInverted = colorScheme === _interfaces.RadioColorScheme.Inverted;

  var getColor = function getColor(color) {
    return color === 'transparent' ? color : selectors.color(color);
  };

  var getColorParams = {
    disabled: disabled,
    error: error,
    getColor: getColor,
    isInverted: isInverted
  };
  var backgroundColor = (0, _utils2.getBackgroundColor)(getColorParams);
  var borderColor = (0, _utils2.getRadioBorderColor)(getColorParams);
  var activeBorderColor = (0, _utils2.getActiveBorderColor)(getColorParams);
  var focusBorderColor = (0, _utils2.getFocusColor)(getColorParams);
  var checkedBorderColor = (0, _utils2.getCheckedBorderColor)(getColorParams);
  var hoverStyles = {};

  if (!disabled) {
    var hoverBorderColor = (0, _utils2.getHoverColor)(getColorParams);
    hoverStyles = {
      'input:hover ~ &, input:hover ~ &:before': {
        borderColor: hoverBorderColor
      },
      'input:hover ~ &': {
        borderWidth: (0, _utils.px)(_constants.HOVERED_RING_SIZE)
      },
      'input:checked:hover ~ &': {
        borderWidth: (0, _utils.px)(_constants.CHECKED_RING_SIZE)
      }
    };
  }

  var outlineStyle = (0, _utils.addOutline)(_constants.DEFAULT_RING_SIZE * 2, _constants.DEFAULT_RING_SIZE + 1, focusBorderColor, undefined, (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE));
  return _objectSpread({
    width: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    height: (0, _utils.px)(_utils.A11Y_INLINE_MIN_SIZE),
    boxSizing: 'border-box',
    borderRadius: '1000px',
    backgroundColor: backgroundColor,
    border: "".concat((0, _utils.px)(_constants.DEFAULT_RING_SIZE), " solid ").concat(borderColor),
    transition: 'border-color 0.2s, border-width 0.2s',
    'input:active ~ &, input:focus ~ &': outlineStyle.focus,
    'input:active ~ &, input:active ~ &:before': {
      borderColor: activeBorderColor
    },
    'input:focus ~ &, input:focus ~ &:before': {
      borderColor: focusBorderColor,
      borderWidth: _constants.DEFAULT_RING_SIZE * 2
    },
    'input:checked ~ &': {
      borderWidth: (0, _utils.px)(_constants.CHECKED_RING_SIZE),
      borderColor: checkedBorderColor
    }
  }, hoverStyles);
});
var _default = Ring;
exports.default = _default;